export default __webpack_public_path__ + "static/media/depram-illustration.c73f1305.svg";